/**
 * Captain's Picks — Curated movie and show recommendations.
 * These are hand-picked films that matter right now, displayed
 * alongside the regular TMDB content on the home page.
 *
 * To update: just change the TMDB IDs and reasons below.
 */

export interface CuratedItem {
  tmdbId: number;
  type: 'movie' | 'tv';
  reason: string;
}

// Featured curated picks — shown in "Captain's Picks" row on home
export const CURATED_PICKS: CuratedItem[] = [
  { tmdbId: 980431, type: 'movie', reason: 'The legend returns' },
  { tmdbId: 73723, type: 'movie', reason: 'Stop broadcasting the apocalypse. Build the alternative.' },
  { tmdbId: 157336, type: 'movie', reason: 'Love transcends dimensions.' },
  { tmdbId: 118340, type: 'movie', reason: 'Broken people forming family by choice.' },
  { tmdbId: 1927, type: 'movie', reason: 'Trauma as body scan.' },
  { tmdbId: 21538, type: 'movie', reason: 'One teacher. Broken kids. Shared language bridges impossible gaps.' },
  { tmdbId: 809, type: 'movie', reason: 'Real love is ugly and chosen.' },
  { tmdbId: 310, type: 'movie', reason: 'Omnipotence doesn\'t solve anything.' },
  { tmdbId: 35790, type: 'movie', reason: 'Good and evil are costumes.' },
  { tmdbId: 13640, type: 'movie', reason: 'When you feel too broken to help.' },
];

// TMDB IDs reference:
// Captain's Picks:
// 980431 = The Legend of Aang
// 73723  = Tomorrowland (2015)
// 157336 = Interstellar (2014)
// 118340 = Guardians of the Galaxy (2014)
// 1927   = Hulk (2003)
// 21538  = Freedom Writers (2007)
// 809    = Shrek 2 (2004)
// 310    = Bruce Almighty (2003)
// 35790  = Megamind (2010)
// 13640  = Hancock (2008)
